export const ENTITY_COLORS = [
  "#1D4ED8",
  "#16A34A",
  "#F59E0B",
  "#DB2777",
  "#06B6D4",
  "#7C3AED",
  "#EA580C",
  "#DC2626",
  "#0F766E",
  "#84CC16",
  "#B45309",
  "#4F46E5",
  "#F43F5E",
  "#059669",
  "#A21CAF",
  "#0284C7",
  "#CA8A04",
  "#BE123C",
  "#22C55E",
  "#C026D3",
  "#0E7490",
  "#F97316",
  "#4338CA",
  "#65A30D",
  "#B91C1C",
  "#0891B2",
  "#D97706",
  "#6D28D9",
  "#15803D",
  "#E11D48",
  "#2563EB",
  "#A16207",
  "#047857",
  "#C2410C",
  "#9333EA",
  "#0369A1",
];

export const SCOPE_COLOR = {
  scope1: "hsl(var(--chart-1))",
  scope2: "hsl(var(--chart-2))",
  scope3: "hsl(var(--chart-3))",
};

// Matches the "Total" series color in EmissionTrendCard so "Total" reads as
// one color across the page; also stays clear of the scope colors above in
// both themes (light-mode --primary would collide with --chart-1 / Scope 1).
export const TOTAL_COLOR = "#06B6D4";

const GOLDEN_ANGLE = 137.508;

export const colorForIndex = (idx) => {
  if (idx >= 0 && idx < ENTITY_COLORS.length) return ENTITY_COLORS[idx];

  const hue = (idx * GOLDEN_ANGLE) % 360;
  const saturation = 78 + ((idx * 11) % 14);
  const lightness = 34 + ((idx * 17) % 18);

  return `hsl(${hue.toFixed(2)} ${saturation}% ${lightness}%)`;
};

// Assign colors from the FULL option list (every BU or country in the org
// tree), not the current selection, so an entity keeps the same color no
// matter which subset is selected.
export const buildEntityColorMap = (entityIds = []) => {
  const map = new Map();
  entityIds.forEach((id, idx) => {
    map.set(String(id), colorForIndex(idx));
  });
  return map;
};
